import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon      from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg      from "../../../asset/images/power&surveillance/star-plus-micro/hero-bg.webp";
import HeroMobileImg  from "../../../asset/images/power&surveillance/star-plus-micro/hero-bg-mobile.webp";
import StabilizerImg  from "../../../asset/images/power&surveillance/star-plus-micro/stabilizer.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .sm { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .sm-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .sm-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .sm-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .sm-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .sm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .sm-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .sm-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .sm-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
  }
  .sm-subnav-item { position: relative; flex-shrink: 0; }
  .sm-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .sm-subnav-link.sm-active { font-weight: 500; }
  .sm-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .sm-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .sm-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .sm-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .sm-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .sm-subnav-dropdown-item:last-child { border-bottom: none; }
  .sm-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .sm-subnav-dropdown-item.sm-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .sm-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .sm-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .sm-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .sm-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .sm-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .sm-sidebar-overlay.open { display: block; }
  .sm-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .sm-sidebar.open { transform: translateX(0); }
  .sm-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .sm-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .sm-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sm-sidebar-nav { flex: 1; overflow-y: auto; }
  .sm-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .sm-sidebar-row:hover { background: #fafafa; }
  .sm-sidebar-row.active { color: #000000; font-weight: 400; }
  .sm-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .sm-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .sm-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .sm-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .sm-sidebar-subitem:last-child { }
  .sm-sidebar-subitem:hover { background: #fafafa; }
  .sm-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .sm-breadcrumb { padding: 60px 0 0 0; }
  .sm-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .sm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .sm-bc-item:hover { color: #EB2019; }
  .sm-bc-item.active { color: #202020; }
  .sm-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .sm-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* DIVIDER */
  .sm-divider { max-width: 1600px; margin: 0 auto; padding: 80px 102px 0px 102px; }
  .sm-divider hr { border: none; border-top: 1px solid #EB2019; opacity: 0.3; }
  .sm-divider-slim { max-width: 1600px; margin: 0 auto; padding: 60px 102px 0 102px; }
  .sm-divider-slim hr { border: none; border-top: 1px solid #EB2019; opacity: 0.3; }

  /* SCROLL ANCHOR */
  .sm-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .sm-section-content { padding: 80px 0 0 0; }
  .sm-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .sm-content-left { flex: 0 0 766px; }
  .sm-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sm-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sm-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .sm-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  /* sub-section red label — Air Cooled / Oil Cooled */
  .sm-sub-label {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #EB2019;
    margin-bottom: 6px; 
  }
  /* range text below label */
  .sm-range {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    margin-bottom: 14px;
  }
  .sm-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .sm-features-tag-bar { width: 10px; background: #EB2019; flex-shrink: 0; }
  .sm-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .sm-features-list { list-style: none; padding: 0; margin: 0; }
  .sm-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .sm-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .sm-hero-bg        { display: block; }
    .sm-subnav         { top: 70px; }
    .sm-anchor         { scroll-margin-top: 110px; }
    .sm-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .sm-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .sm-hero              { height: 300px; }
    .sm-hero-content      { padding: 0 32px; }
    .sm-hero-title        { font-size: 26px; }
    .sm-breadcrumb        { padding: 28px 0 0 0; }
    .sm-breadcrumb-inner  { padding: 0 24px; }
    .sm-inner             { padding: 0 24px; }
    .sm-divider           { padding: 0px 32px 0px 32px; }
    .sm-divider:last-child { display: none; }
    .sm-divider-slim      { padding: 20px 24px 0 24px; }
    .sm-section-content   { padding: 40px 0 0 0; }
    .sm-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .sm-content-left      { flex: none; width: 100%; }
    .sm-features-tag      { margin: 24px 0 24px 0; }
    .sm-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .sm-img-col           { min-height: 260px; width: 100%; }
    .sm-img-wrap          { max-height: 450px; }
    .sm-red-title         { font-size: 24px; margin-bottom: 10px; }
    .sm-sub-label         { font-size: 16px; }
    .sm-range             { font-size: 14px; }
    .sm-features-list li  { font-size: 14px; }
    .sm-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .sm-subnav           { display: none; }
    .sm-mobile-bar       { display: flex; height: 46px; }
    .sm-sidebar-header   { height: 46px; }
    .sm-anchor           { scroll-margin-top: 80px; }
    .sm-hero-bg          { display: none; }
    .sm-hero-bg-mobile   { display: block; }
    .sm-hero             { height: 370px; }
    .sm-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .sm-hero-title       { font-size: 22px; }
    .sm-breadcrumb       { padding: 22px 0 0 0; }
    .sm-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .sm-bc-item          { font-size: 14px; }
    .sm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .sm-inner            { padding: 0 16px; }
    .sm-divider          { padding: 0px 16px; }
    .sm-divider-slim     { padding: 30px 16px 0 16px; }
    .sm-section-content  { padding: 60px 0 0 0; }
    .sm-section-content:last-child { padding: 60px 0 0px 0; }
    .sm-divider:last-child { display: none; }
    .sm-content-grid:last-child { margin-bottom: 60px !important; }
    .sm-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .sm-img-wrap         { max-height: 260px; }
    .sm-red-title        { font-size: 20px; margin-bottom: 10px; }
    .sm-sub-label        { font-size: 15px; }
    .sm-range            { font-size: 14px; }
    .sm-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/business/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",    href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)",  href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, active: true, href: "#" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "sm-product-1",
    title: "STAR+ SERIES MICROCONTROLLER  BASED STABILIZERS",
    subSections: [
      { label: "Air Cooled Stabilizer", range: "Range- 3 KVA To 300 KVA" },
      { label: "Oil Cooled Stabilizer", range: "Range- 3 KVA To 4000 KVA" },
    ],
    features: [
      "LCD Display",
      "Input High Voltage protection",
      "SPD Type 2+1 extra protection.",
      "Under /Over voltage cut-off,",
      "Upper Limit & Lower Limit,",
      "Electronic overload cut-off,",
      "Short Circuit protection,",
      "Spike & Surge Prevention,",
      "Single phase prevention & Phase Reversal Trip,",
      "Service bypass,",
      "Fault annunciation indications.",
    ],
    imgRight: true,
    imgSrc: StabilizerImg,
  },
];

/* ── SubnavItem — opens on hover; items link out to each series' page ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="sm-subnav-item">
        <a href={item.href || "#"} className={`sm-subnav-link${item.active ? " sm-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="sm-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`sm-subnav-link${item.active ? " sm-active" : ""}`}>
        {item.label}
        <span className={`sm-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="sm-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`sm-subnav-dropdown-item${child.active ? " sm-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`sm-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`sm-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`sm-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="sm-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`sm-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function StarPlusMicrocontroller() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="sm">
        <section className="sm-hero">
          <img className="sm-hero-bg" src={HeroBgImg} alt="" />
          <img className="sm-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="sm-hero-content">
            <h1 className="sm-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .sm */}
      <nav className="sm-subnav" aria-label="Product categories">
        <div className="sm-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .sm */}
      <div className="sm-mobile-bar">
        <span className="sm-mobile-bar-title">Star+ Series Microcontroller</span>
        <button className="sm-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`sm-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`sm-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="sm-sidebar-header">
          <span className="sm-sidebar-header-title">Star+ Microcontroller</span>
          <button className="sm-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="sm-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="sm">
        <nav className="sm-breadcrumb" aria-label="Breadcrumb">
          <div className="sm-breadcrumb-inner">
            <a href="/" className="sm-bc-item">Home</a>
            <span className="sm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="sm-bc-item">Business</a>
            <span className="sm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="sm-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="sm-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="sm-anchor" />
            <section className="sm-section-content">
              <div className="sm-inner">
                <div
                  className="sm-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="sm-content-left">
                    <h2 className="sm-red-title">{product.title}</h2>

                    {/* Air Cooled + Oil Cooled sub-sections */}
                    {product.subSections.map((s, i) => (
                      <div key={i}>
                        <p className="sm-sub-label">{s.label}</p>
                        <p className="sm-range">{s.range}</p>
                      </div>
                    ))}

                    <div className="sm-features-tag">
                      <div className="sm-features-tag-bar" />
                      <span className="sm-features-tag-text">Features</span>
                    </div>
                    <ul className="sm-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="sm-img-col">
                    <div className="sm-img-wrap">
                      {product.imgSrc &&
                        <img className="sm-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="sm-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}